/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import DateTimeDisplay from './DateTimeDisplay'
import useCountDown from './hook'

const ExpiredNotice = () => {
  return (
    <div className='expired-notice'>
      <span>Expired!!!</span>
      <p>Please select a future date and time.</p>
    </div>
  )
}

const ShowCounter = ({ days, hours, minutes, seconds, isDarkMode }) => {
  return (
    <div className='show-counter'>
      <p
        className='countdown-link'
        css={css`
          color: ${isDarkMode ? '#fff' : '#000'};
        `}
      >
        <DateTimeDisplay
          isDanger={days <= 3}
          type='Days'
          value={days}
          isDarkMode={isDarkMode}
        />
        <p
          css={css`
            color: ${isDarkMode ? '#fff' : '#000'};
          `}
        >
          :
        </p>
        <DateTimeDisplay
          isDanger={false}
          type='Hours'
          value={hours}
          isDarkMode={isDarkMode}
        />
        <p
          css={css`
            color: ${isDarkMode ? '#fff' : '#000'};
          `}
        >
          :
        </p>
        <DateTimeDisplay
          isDanger={false}
          type='Mins'
          value={minutes}
          isDarkMode={isDarkMode}
        />
        <p
          css={css`
            color: ${isDarkMode ? '#fff' : '#000'};
          `}
        >
          :
        </p>
        <DateTimeDisplay
          isDanger={false}
          type='Seconds'
          value={seconds}
          isDarkMode={isDarkMode}
        />
      </p>
    </div>
  )
}

export const Countdown = ({ targetDate, isDarkMode }) => {
  const [days, hours, minutes, seconds] = useCountDown(targetDate)

  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        isDarkMode={isDarkMode}
      />
    )
  }
}
